export default __webpack_public_path__ + "static/media/Abakumov_Evgeniy_Mikhailovich.2749ea90.webp";